import React from 'react';

import Paper from '@material-ui/core/Paper';
import withWidth from '@material-ui/core/withWidth'
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Collapse from '@material-ui/core/Collapse';
import Slide from '@material-ui/core/Slide';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import {BannerIklan, MiniIklan, DialogShowAds, PurchaseListItem} from '.';

import { Divider , Box, Button, Grid, Fade, CircularProgress} from '@material-ui/core';
import { toDateTimestamp } from '../../components/Fragment/Clock';


const IklanAdminFragment = React.memo((props)=>{

  const {
    adsMode,
    navBarHeight,
    isMobile,
    firebase,
    currentUser,
    authUser,
    width,
  }=props

  const [listPurchaseAds,setListPurchaseAds]=React.useState([])
  const [purchaseToPreview,setPurchaseToPreview]=React.useState()

  const handleClosePreviewAds=React.useCallback(()=>{
    setPurchaseToPreview(null)
  },[])

  
  const handleClickPurchaseAds=React.useCallback((ads)=>{
    setPurchaseToPreview(ads)
  },[])


  React.useEffect(()=>{
    if(!firebase||!authUser)return
    
    let query=firebase.fs.collection("apps/CariIklan/purchases")
    query=query.orderBy("purchaseDate","desc")
    return query.onSnapshot((querySnapshot) => {
      var purchaseAds = [];
      querySnapshot.forEach((doc) => {
          purchaseAds.push(doc.data());
      });
      setListPurchaseAds(purchaseAds)
    });
  },[firebase,authUser])

  const [adsToShow,setAdsToShow]=React.useState()
  const handleShowAds=React.useCallback((ads)=>{
    setAdsToShow(ads)
  },[])
  const handleHideAds=React.useCallback(()=>{
    setAdsToShow(null)
  },[])

  return (
    <Box>
      <Grid
        container
        spacing={2}
        direction="row"
        //justifyContent="center"
        alignItems="stretch"
      >
        <Grid 
          item
          xs={12}
          sm={6}
        >
          <Paper 
            //elevation={3} 
            style={{
              margin:isMobile?"16px 8px":"16px auto",
              padding:"16px",
              height:adsMode==="minimize"?"calc(100vh - "+(82+navBarHeight)+"px)":"calc(100vh - "+(156+navBarHeight)+"px)",//64
              transition:"height 0.5s",
              //overflowY:"auto",
              //maxWidth:"600px",
              scrollBehavior: "smooth",
              overflowY:"scroll",
            }}
          >
            {listPurchaseAds.length<=0&&<Typography
              style={{
                textAlign:"center",
              }}
            >Tidak ditemukan pembelian</Typography>}
            {listPurchaseAds.map((purchase)=>{
              return (
                <PurchaseListItem
                  key={purchase.id}
                  purchase={purchase}
                  onClick={()=>handleClickPurchaseAds(purchase)}
                  selected={width!=="xsp"&&purchaseToPreview?.id===purchase.id}
                />
              )
            })}

            <DialogShowAds
              adsToPreview={adsToShow}
              handleCloseAds={handleHideAds}
            />

          </Paper>
        </Grid>

        
        <Grid 
          item
          xs={false}
          sm={6}
          style={{
            display:width==="xs"?"none":"initial",
            height:"100vh",
            overflowY:"scroll",
          }}
        >
          <Fade
            in={width!=="xs"}
            timeout={500}
          >
            <Paper
              style={{
                margin:isMobile?"16px 8px":"16px auto",
                padding:"16px",
                height:adsMode==="minimize"?"calc(100vh - "+(82+navBarHeight)+"px)":"calc(100vh - "+(156+navBarHeight)+"px)",//64
                overflowY:"scroll",
              }}
            >
              {!purchaseToPreview&&<>
                <Typography
                  style={{
                    textAlign:"center",
                  }}
                >Detil pembelian belum tersedia
                </Typography>
              </>}
              <PurchaseDetailFragment
                firebase={firebase}
                purchase={purchaseToPreview}
                onClickAds={handleShowAds}
                authUser={authUser}
                currentUser={currentUser}
              />
            </Paper>
          </Fade>
        </Grid>
     
        
      </Grid>

      <DialogPurchaseDetail
        firebase={firebase}
        open={width==="xs"&&!!purchaseToPreview}
        purchase={purchaseToPreview}
        onClose={handleClosePreviewAds}
        onClickAds={handleShowAds}
        authUser={authUser}
        currentUser={currentUser}
      />
      
    </Box>
  )
})


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const DialogPurchaseDetail=React.memo((props)=>{
  const {
    open,
    firebase,
    authUser,
    currentUser,
    purchase,
    onClose,
    onClickAds,
  }=props


  

  return (
    <Dialog fullScreen open={open} onClose={onClose} TransitionComponent={Transition}  >
      <AppBar style={{position: 'sticky',top:0}} color="primary">
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={onClose}>
            <ArrowBackIcon />
          </IconButton>
          <Typography
            variant="h5"
            style={{
              flexGrow:1,
              padding:"0px 8px",
            }}
          >
            {purchase?.status}
          </Typography>        
        </Toolbar>
      </AppBar>
      <Box
        style={{
          padding:"16px",
        }}
      >
        <PurchaseDetailFragment
          firebase={firebase}
          purchase={purchase}
          onClickAds={onClickAds}
          authUser={authUser}
          currentUser={currentUser}
        />
      </Box>
      
      
    </Dialog>
  )
})

const PurchaseDetailFragment=React.memo(props=>{
  const {
    firebase,
    purchase,
    onClickAds,
    authUser,
    currentUser,
    onReject,
    onContentReject,
    onApprove,
  }=props

  const [isLoading,setisLoading]=React.useState(false)
  const [outstandingReviewAds,setOutstandingReviewAds]=React.useState()

  React.useEffect(()=>{
    if(!firebase||!purchase)return
    //console.log(purchase)
    setisLoading(true)
    let query=firebase.fs.doc("apps/CariIklan/review-ads/"+purchase.id)
    //query=query.where("id","==",ads.id).limit(1)
    return query.onSnapshot((querySnapshot) => {
      //console.log(querySnapshot)
      if(querySnapshot.exists){
        setOutstandingReviewAds(querySnapshot.data())
      }else{
        setOutstandingReviewAds(null)
      }
      setisLoading(false)
    },(e)=>{
      setisLoading(false)
      setOutstandingReviewAds(null)
      alert(e)
      console.log(e)
    });
  },[purchase,firebase])

  const [isProcessing,setIsProcessing]=React.useState(false)
  const handleApprove=React.useCallback(()=>{
    console.log(!authUser+" "+!currentUser+" "+!purchase+" "+!outstandingReviewAds)
    if(!authUser||!currentUser||!purchase||!outstandingReviewAds)return
    let ok=window.confirm("Pastikan pembayaran telah valid dan konten iklan tidak melanggar peraturan.\n\n\nApakah Anda yakin untuk memublikasikan iklan ini?")
    if(!ok)return

    var batch = firebase.fs.batch();

    var reviewRef = firebase.fs.doc("apps/CariIklan/review-ads/"+purchase.id)
    var purchaseRef = firebase.fs.doc("apps/CariIklan/purchases/"+purchase.id)
    var liveRef = firebase.fs.doc("apps/CariIklan/live-ads/"+purchase.id)

    let objApproval={
      status:"Aktif",
      contentStatus:"Aktif",
      denial:"",
    }
    let objPurchaseApproval={
      ...objApproval,
      employeeId:authUser.uid,
      employeeName:currentUser.name,

      /* paymentDate:0,// EMPLOYEE
      paymentAmount:parseInt(purchaseAmount)||0,// EMPLOYEE
      paymentMethod:"QRIS",
      purchaseDate:0,// EMPLOYEE
      companyName:"Digital Factory",
      companyAddress:"",//TODO
      companyPhone:"0895399745202",
      companyNPWP:"",
      companyId:"",//TODO
      companyTown:"Blitar", */
    }
    let objLiveAds={
      id:outstandingReviewAds.id||"",
      name:outstandingReviewAds.name||"",
      description:outstandingReviewAds.description||"",
      purchaseURL:outstandingReviewAds.purchaseURL||"",
      sellerPhone:outstandingReviewAds.sellerPhone||"",
      sellerName:outstandingReviewAds.sellerName||"",
      purchasePrice:outstandingReviewAds.purchasePrice||0,
      photoURL:outstandingReviewAds.photoURL||"",
      thumb_photoURL:outstandingReviewAds.thumb_photoURL||"",

      pricePerView:outstandingReviewAds.pricePerView||0,
      userId:outstandingReviewAds.userId||"",

      purchaseDate:outstandingReviewAds.purchaseDate||(new Date()).getTime(),

      ...objApproval,
    }
    
    batch.set(reviewRef, objApproval,{merge:true});
    batch.set(purchaseRef, objPurchaseApproval,{merge:true});
    batch.set(liveRef,objLiveAds,{merge:true});

    setIsProcessing(true)
    batch.commit()
    .then(() => {
      setIsProcessing(false)
      //setOutstandingReviewAds()
      if(!!onApprove)onApprove()
    }).catch((e)=>{
      alert(e)
      setIsProcessing(false)
    })
    
  },[authUser,outstandingReviewAds,currentUser,onApprove,purchase,firebase])

  const handleContentReject=React.useCallback(()=>{
    if(!authUser||!currentUser||!purchase)return
    let denialText=window.prompt("Alasan konten melanggar")
    if(denialText===null)return

    var batch = firebase.fs.batch();

    var reviewRef = firebase.fs.doc("apps/CariIklan/review-ads/"+purchase.id)
    var purchaseRef = firebase.fs.doc("apps/CariIklan/purchases/"+purchase.id)
    var liveRef = firebase.fs.doc("apps/CariIklan/live-ads/"+purchase.id)

    let objDenial={
      status:"Ditolak",
      denial:denialText,
    }
    let objPurchaseDenial={
      ...objDenial,
      contentStatus:"Ditolak",
      employeeId:authUser.uid,
      employeeName:currentUser.name,
    }
    
    batch.set(reviewRef, objDenial,{merge:true});
    batch.set(purchaseRef, objPurchaseDenial,{merge:true});
    batch.delete(liveRef);

    setIsProcessing(true)
    batch.commit()
    .then(() => {
      setIsProcessing(false)
      if(!!onContentReject)onContentReject()
    }).catch((e)=>{
      alert(e)
      setIsProcessing(false)
    })
  },[authUser,currentUser,onContentReject,purchase,firebase])

  const handleReject=React.useCallback(()=>{
    if(!authUser||!currentUser||!purchase)return
    let denialText=window.prompt("Alasan pembayaran ditolak")
    if(denialText===null)return

    var batch = firebase.fs.batch();

    var reviewRef = firebase.fs.doc("apps/CariIklan/review-ads/"+purchase.id)
    var purchaseRef = firebase.fs.doc("apps/CariIklan/purchases/"+purchase.id)
    var liveRef = firebase.fs.doc("apps/CariIklan/live-ads/"+purchase.id)

    let objDenial={
      status:"Ditolak",
      denial:denialText,
    }
    let objPurchaseDenial={
      ...objDenial,
      contentStatus:"Aktif",
      employeeId:authUser.uid,
      employeeName:currentUser.name,
    }
    
    batch.set(reviewRef, objDenial,{merge:true});
    batch.set(purchaseRef, objPurchaseDenial,{merge:true});
    batch.delete(liveRef);

    setIsProcessing(true)
    batch.commit()
    .then(() => {
      setIsProcessing(false)
      if(!!onReject)onReject()
    }).catch((e)=>{
      alert(e)
      setIsProcessing(false)
    })
  },[authUser,currentUser,purchase,onReject,firebase])

  const [openDetailIklan,setOpenDetailIklan]=React.useState(false)
  const handleToggleDetailIklan=React.useCallback(()=>{
    setOpenDetailIklan(prev=>!prev)
  },[])


  return (
    <>
      <Collapse
        in={isLoading}
        timeout={500}
      >
        <CircularProgress/>
      </Collapse>

      <Collapse
        in={!!outstandingReviewAds}
        timeout={500}
      >
        <Box
          //style={{
          //margin:"16px"
          //}}
        >
          <Typography
            style={{
              fontWeight:"bold",
              textAlign:"center",
              marginTop:"16px",
            }}
            variant="h5"
          >
            {outstandingReviewAds?.name}
          </Typography>

          <Typography
            style={{
              textAlign:"center",
              marginBottom:"16px",
            }}
            variant="h6"
          >
            {outstandingReviewAds?.sellerName}
          </Typography>
          

          <Box
            style={{
              textAlign:"center",
              marginTop:"16px",
              marginBottom:"32px",
              backgroundColor:"black",
              border:"1px solid black",
              maxHeight:"82px",
              overflowY:"hidden",
            }}
          >
            <MiniIklan
              liveAds={outstandingReviewAds}
              light={true}
              onClick={onClickAds}
              disableCounter={true}
            />
            <MiniIklan
              liveAds={outstandingReviewAds}
              light={true}
              onClick={onClickAds}
              disableCounter={true}
            />
            <MiniIklan
              liveAds={outstandingReviewAds}
              light={true}
              onClick={onClickAds}
              disableCounter={true}
            />
            
          </Box>

          <Box
            style={{
              textAlign:"center",
              marginTop:"32px",
              marginBottom:"32px",
              border:"3px solid grey",
            }}
          >
            <BannerIklan
              ads={outstandingReviewAds}
              onClick={onClickAds}
              disableCounter={true}
            />
          </Box>
        
          <Box
            style={{
              textAlign:"center",
              marginTop:"32px",
              marginBottom:"32px",
            }}
          >
            <a href={outstandingReviewAds?.photoURL||"#"} target="_blank" rel="noopener noreferrer">
              <img
                style={{
                  maxHeight:"400px",
                  width:"100%",
                  objectFit:"contain",
                  border:"1px solid black",
                }}
                src={outstandingReviewAds?.photoURL||"#"}
                alt="iklan"
              />
            </a>
          </Box>

        
          <Paper
            style={{
              padding:"16px",
            }}
          >
            <Box
              style={{
                display:"flex",
                justifyContent:"space-between",
              }}
            >
              <Typography
                style={{
                  fontWeight:"bold",
                  alignSelf:"center",
                  flexGrow:1,
                  cursor:"pointer",
                }}
                variant="h6"
                onClick={handleToggleDetailIklan}
                onKeyDown={handleToggleDetailIklan}
                tabIndex="0"
                role="button"
              >
                Detil iklan
              </Typography>
              <IconButton
                style={{
                  alignSelf:"center",
                }}
                onClick={handleToggleDetailIklan}
              >
                {openDetailIklan?<ExpandLessIcon/>:<ExpandMoreIcon/>}
              </IconButton>
            </Box>
            
            <Collapse
              in={openDetailIklan}
              timeout={500}
            >
              <Box>
                <Box
                  style={{
                    display:"flex",
                    justifyContent:"space-between",
                  }}
                >
                  <Typography
                    style={{
                      alignSelf:"flex-start",
                    }}
                  >Harga Jual
                  </Typography>
                  <Typography
                    style={{
                      alignSelf:"flex-start",
                    }}
                  >Rp {outstandingReviewAds?.purchasePrice?.toLocaleString("ID-id")}
                  </Typography>
                </Box>

                <Box
                  style={{
                    display:"flex",
                    justifyContent:"space-between",
                  }}
                >
                  <Typography
                    style={{
                      alignSelf:"flex-start",
                    }}
                  >Deskripsi
                  </Typography>
                  <Typography
                    style={{
                      alignSelf:"flex-start",
                    }}
                  >{outstandingReviewAds?.description}
                  </Typography>
                </Box>

                <Box
                  style={{
                    display:"flex",
                    justifyContent:"space-between",
                  }}
                >
                  <Typography
                    style={{
                      alignSelf:"flex-start",
                    }}
                  >User Id
                  </Typography>
                  <Typography
                    style={{
                      alignSelf:"flex-start",
                    }}
                  >{outstandingReviewAds?.userId}
                  </Typography>
                </Box>

                <Box
                  style={{
                    display:"flex",
                    justifyContent:"space-between",
                  }}
                >
                  <Typography
                    style={{
                      alignSelf:"flex-start",
                    }}
                  >Phone
                  </Typography>
                  <Typography
                    style={{
                      alignSelf:"flex-start",
                    }}
                  >{outstandingReviewAds?.sellerPhone}
                  </Typography>
                </Box>

                <Box
                  style={{
                    display:"flex",
                    justifyContent:"space-between",
                  }}
                >
                  <Typography
                    style={{
                      alignSelf:"flex-start",
                    }}
                  >URL
                  </Typography>
                  <Typography
                    style={{
                      alignSelf:"flex-start",
                    }}
                  ><a href={outstandingReviewAds?.purchaseURL} target="_blank" rel="noopener noreferrer">{outstandingReviewAds?.purchaseURL}</a>
                  </Typography>
                </Box>

                <Box
                  style={{
                    display:"flex",
                    justifyContent:"space-between",
                  }}
                >
                  <Typography
                    style={{
                      alignSelf:"flex-start",
                    }}
                  >Harga per klik tayang
                  </Typography>
                  <Typography
                    style={{
                      alignSelf:"flex-start",
                    }}
                  >Rp {outstandingReviewAds?.pricePerView?.toLocaleString("ID-id")}
                  </Typography>
                </Box>
              </Box>
            </Collapse>
          </Paper>
          
          <Button 
            style={{
              marginTop:"32px",
            }}
            variant="outlined" 
            color="secondary"
            fullWidth
            disabled={isProcessing}
            onClick={handleContentReject}
          >
            Konten melanggar ?
          </Button>
          

          {/* <Typography variant="h6" style={{textAlign:"left",fontWeight:"bold"}}>Rp {outstandingReviewAds?.purchasePrice?.toLocaleString("ID-id")}</Typography>
          <Typography variant="subtitle1" style={{margin:"16px 0px"}}>{outstandingReviewAds?.description}</Typography> */}
          {/* <Typography variant="body1">User Id : {ads?.userId}</Typography>
          <Typography variant="body1">Phone : {ads?.sellerPhone}</Typography>
          <Typography variant="body1">URL : <a href={ads?.purchaseURL} target="_blank" rel="noopener noreferrer">{ads?.purchaseURL}</a></Typography>
          <Typography variant="body1">Harga per klik tayang : Rp {ads?.pricePerView?.toLocaleString("ID-id")}</Typography> */}

          

          {/* .<Typography>description : {ads?.description}</Typography>
          .<Typography>id : {ads?.id}</Typography>
          .<Typography>name : {ads?.name}</Typography>
          .<Typography>photoURL : {ads?.photoURL}</Typography>
          .<Typography>pricePerView : {ads?.pricePerView}</Typography>
          .<Typography>purchaseURL : {ads?.purchaseURL}</Typography>
          .<Typography>purchasePrice : {ads?.purchasePrice}</Typography>
          .<Typography>sellerName : {ads?.sellerName}</Typography>
          .<Typography>sellerPhone : {ads?.sellerPhone}</Typography>
          .<Typography>thumb_photoURL : {ads?.thumb_photoURL}</Typography>
          .<Typography>userId : {ads?.userId}</Typography> */}

          <Divider style={{margin:"32px 0px"}}/>

          <Typography
            style={{
              fontWeight:"bold",
              marginTop:"16px",
            }}
            variant="h6"
          >Status Pembelian
          </Typography>

          {/* <Box
            style={{
              textAlign:"center",
            }}
          >
            <a href={purchase?.thumb_photoURL||"#"} target="_blank" rel="noopener noreferrer">
              <img
                style={{
                  height:"80px",
                  width:"80px",
                  objectFit:"contain",
                  border:"1px solid black",
                }}
                src={purchase?.thumb_photoURL||"#"}
                alt="iklan"
              />
            </a>
          </Box> */}

          <ListItem
            style={{
              height:"100px",
              overflowY:"hidden",
              padding:"0px 8px",
            }}
          >
            <ListItemIcon>
              <a href={purchase?.thumb_photoURL||"#"} target="_blank" rel="noopener noreferrer">
                <img
                  style={{
                    height:"80px",
                    width:"80px",
                    objectFit:"contain",
                    border:"1px solid black",
                  }}
                  src={purchase?.thumb_photoURL||"#"}
                  alt="thumbnail photo"
                />
              </a>
            </ListItemIcon>
            
            <ListItemText
              primary={"Status : "+purchase?.status}
              secondary={<span>Konten : {purchase?.contentStatus}</span>}
              secondaryTypographyProps={{style:{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}}
              primaryTypographyProps={{style:{fontWeight:"bold"}}}
              style={{
                paddingLeft:"16px",
              }}
            />
          </ListItem>
          <Typography
            style={{
              fontWeight:"bold",
              color:"red",
            }}
            variant="h6"
          >{purchase?.denial}
          </Typography>

          <Typography
            style={{
              fontWeight:"bold",
              marginTop:"16px",
            }}
            variant="h6"
          >Pelanggan
          </Typography>

          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >ID
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.customerId}
            </Typography>
          </Box>

          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Nama
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.customerName}
            </Typography>
          </Box>

          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Email
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.customerEmail}
            </Typography>
          </Box>

          <Typography
            style={{
              fontWeight:"bold",
              marginTop:"16px",
            }}
            variant="h6"
          >Tagihan Biaya
          </Typography>

          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Biaya {purchase?.purchaseName} {purchase?.purchaseView} x Rp {purchase?.pricePerView?.toLocaleString("ID-id")}
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.amount?.toLocaleString("ID-id")}
            </Typography>
          </Box>

          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Diskon ({purchase?.discount})
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.discountValue?.toLocaleString("ID-id")}
            </Typography>
          </Box>

          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Pajak ({purchase?.tax})
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.taxValue?.toLocaleString("ID-id")}
            </Typography>
          </Box>

          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
              fontWeight:"bold",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Total Tagihan
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
                fontWeight:"bold",
              }}
            >{purchase?.billableAmount?.toLocaleString("ID-id")}
            </Typography>
          </Box>


          <Typography
            style={{
              fontWeight:"bold",
              marginTop:"16px",
            }}
            variant="h6"
          >Pembayaran
          </Typography>

          <Box
            style={{
              textAlign:"center",
            }}
          >
            <a href={purchase?.paymentURL||"#"} target="_blank" rel="noopener noreferrer">
              <img
                style={{
                  maxHeight:"250px",
                  width:"100%",
                  objectFit:"contain",
                  border:"1px solid black",
                }}
                src={purchase?.paymentURL||"#"}
                alt="bukti bayar"
              />
            </a>
          </Box>
          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Metode
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.paymentMethod}
            </Typography>
          </Box>
          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Pembayaran
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.paymentAmount}
            </Typography>
          </Box>
          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Tanggal
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{toDateTimestamp(purchase?.paymentDate)}
            </Typography>
          </Box>
          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Pembelian
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.purchaseName}
            </Typography>
          </Box>
          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Penayangan
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.purchaseView}
            </Typography>
          </Box>
          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Harga per klik tayang
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.pricePerView}
            </Typography>
          </Box>

          {/* <Typography
            style={{
              fontWeight:"bold",
            }}
            variant="h6"
          >Status
          </Typography>
          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Pembelian
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.status}
            </Typography>
          </Box>
          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Konten
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.contentStatus}
            </Typography>
          </Box>
          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Penolakan
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.denial}
            </Typography>
          </Box> */}

          <Typography
            style={{
              fontWeight:"bold",
              marginTop:"16px",
            }}
            variant="h6"
          >Petugas
          </Typography>
          
          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >ID
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.companyId}
            </Typography>
          </Box>
          
          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Perusahaan
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.companyName}
            </Typography>
          </Box>
          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Telepon
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.companyPhone}
            </Typography>
          </Box>
          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Alamat
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.companyAddress}
            </Typography>
          </Box>
          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Kota
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.companyTown}
            </Typography>
          </Box>
          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >NPWP
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.companyNPWP}
            </Typography>
          </Box>
          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >ID Karyawan
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.employeeId}
            </Typography>
          </Box>

          <Box
            style={{
              display:"flex",
              justifyContent:"space-between",
            }}
          >
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >Nama
            </Typography>
            <Typography
              style={{
                alignSelf:"flex-start",
              }}
            >{purchase?.employeeName}
            </Typography>
          </Box>

          {/* .<Typography>amount : {outstandingPurchaseAds?.amount}</Typography>
          .<Typography>billableAmount : {outstandingPurchaseAds?.billableAmount}</Typography>
          .<Typography>companyAddress : {outstandingPurchaseAds?.companyAddress}</Typography>
          .<Typography>companyId : {outstandingPurchaseAds?.companyId}</Typography>
          .<Typography>companyNPWP : {outstandingPurchaseAds?.companyNPWP}</Typography>
          .<Typography>companyName : {outstandingPurchaseAds?.companyName}</Typography>
          .<Typography>companyPhone : {outstandingPurchaseAds?.companyPhone}</Typography>
          .<Typography>companyTown : {outstandingPurchaseAds?.companyTown}</Typography>
          .<Typography>contentStatus : {outstandingPurchaseAds?.contentStatus}</Typography>
          .<Typography>customerEmail : {outstandingPurchaseAds?.customerEmail}</Typography>
          .<Typography>customerId : {outstandingPurchaseAds?.customerId}</Typography>
          .<Typography>customerName : {outstandingPurchaseAds?.customerName}</Typography>
          .<Typography>denial : {outstandingPurchaseAds?.denial}</Typography>
          .<Typography>discount : {outstandingPurchaseAds?.discount}</Typography>
          .<Typography>discountValue : {outstandingPurchaseAds?.discountValue}</Typography>
          .<Typography>employeeId : {outstandingPurchaseAds?.employeeId}</Typography>
          .<Typography>employeeName : {outstandingPurchaseAds?.employeeName}</Typography>
          <Typography>id : {outstandingPurchaseAds?.id}</Typography>
          .<Typography>paymentAmount : {outstandingPurchaseAds?.paymentAmount}</Typography>
          .<Typography>paymentDate : {outstandingPurchaseAds?.paymentDate}</Typography>
          .<Typography>paymentMethod : {outstandingPurchaseAds?.paymentMethod}</Typography>
          .<Typography>paymentURL : {outstandingPurchaseAds?.paymentURL}</Typography>
          .<Typography>pricePerView : {outstandingPurchaseAds?.pricePerView}</Typography>
          .<Typography>purchaseDate : {outstandingPurchaseAds?.purchaseDate}</Typography>
          .<Typography>purchaseName : {outstandingPurchaseAds?.purchaseName}</Typography>
          .<Typography>purchaseView : {outstandingPurchaseAds?.purchaseView}</Typography>
          .<Typography>status : {outstandingPurchaseAds?.status}</Typography>
          .<Typography>tax : {outstandingPurchaseAds?.tax}</Typography>
          .<Typography>taxValue : {outstandingPurchaseAds?.taxValue}</Typography>
          .<Typography>thumb_photoURL : {outstandingPurchaseAds?.thumb_photoURL}</Typography> */}

          <Button 
            style={{
              marginTop:"16px",
            }}
            variant="contained" 
            color="secondary"
            fullWidth
            disabled={isProcessing}
            onClick={handleApprove}
          >
            Pembayaran dan konten disetujui
          </Button>

          <Button 
            style={{
              marginTop:"16px",
            }}
            variant="outlined" 
            color="secondary"
            fullWidth
            disabled={isProcessing}
            onClick={handleReject}
          >
            Pembayaran ditolak
          </Button>

        </Box>
        
      </Collapse>
    </>
  )
})

const FieldEditor=React.memo((props)=>{
  const {
    obj,
    field,
  }=props
  
  return (
    <>
    </>
  )
})


export default IklanAdminFragment